/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const latestInterviewBookingDataStatusSchema = z.enum(['confirmed', 'cancelled'])

export type LatestInterviewBookingDataStatusSchema = z.infer<typeof latestInterviewBookingDataStatusSchema>
